<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_1 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<div class="tour-step-21">
			<v-row class="mb-2">
				<v-col>
					<div class="d-flex justify-end mb-5">
						<v-btn
							v-if="isAccountManager"
							color="secondary"
							@click="downloadAllFiles()"
							:disabled="isLoading || nessunFileCaricato"
						>
							{{ nessunFileCaricato ? 'Nessun documento caricato' : 'Scarica tutti i documenti' }}
						</v-btn>
					</div>
					
					<div class="mb-4">
						Carica l'<b>Attestazione di avvenuta Predisposizione della Domanda</b>. Questa attestazione in formato PDF, contiene i codici di invio necessari per la procedura di invio dell’istanza (Click Day) ed è disponibile solo dopo aver compilato la domanda sul sito del MIMIt.<br>
						Il modulo a cui facciamo riferimento è quello con la seguente intestazione:<br>
						<a href="https://drive.google.com/file/d/1N_GwR_KQM98DbguG45eugsOlIrJINvey/view?usp=drive_link">
							https://drive.google.com/file/d/1N_GwR_KQM98DbguG45eugsOlIrJINvey/view?usp=drive_link
						</a><br>
						Inviaci questo modulo senza effettuare alcuna modifica o spostamento dei dati, per minimizzare il rischio di generare errori che potrebbero compromettere le successive fasi di invio della domanda e quindi del ricevimento dei fondi.
					</div>
					
					<template v-if="action == 'store' || (action == 'edit' && ((isCliente && pratica.id_stato_fase_1 != 30) || isAccountManager))">
						<v-badge
							:value="haveFilesBeenModified.attestazione_predisposizione_domanda"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.attestazione_predisposizione_domanda"
								label="Attestazione di avvenuta Predisposizione della Domanda"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setChanged(files.attestazione_predisposizione_domanda)"
								@click:clear="pratica.path_attestazione_predisposizione_domanda = null"
								:loading="isLoadingAttestazionePredisposizioneDomanda"
								:disabled="isLoading || tourIsRunning"
							>
								<template
									v-slot:append
									v-if="pratica.path_attestazione_predisposizione_domanda !== null && !isLoadingAttestazionePredisposizioneDomanda"
								>
									<template>
										<v-progress-circular
											v-if="downloadingAttestazionePredisposizioneDomanda"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.path_attestazione_predisposizione_domanda, 'attestazione_predisposizione_domanda')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					
					<template v-else-if="action == 'show' || isCoordinatore || (isCliente && pratica.id_stato_fase_1 == 30)">
						<v-text-field
							:value="getFileNameFromPath(pratica.path_attestazione_predisposizione_domanda)"
							label="Attestazione di avvenuta Predisposizione della Domanda"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.path_attestazione_predisposizione_domanda !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingAttestazionePredisposizioneDomanda"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_attestazione_predisposizione_domanda, 'attestazione_predisposizione_domanda')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>
				</v-col>
			</v-row>
			
			<v-row class="mb-2">
				<v-col>
					<div class="mb-4">
						Carica anche il <b>Modulo di Domanda </b> in formato PDF cliccando sul riquadro qui in basso. Sarà disponibile dopo che avrai completato la compilazione della domanda sul sito del MIMIt.<br>
						Il modulo a cui facciamo riferimento è quello con la seguente intestazione:<br>
						<a href="https://drive.google.com/file/d/1b_ay5JBRmZP_tukT-OeNceSZu7UA8br0/view?usp=drive_link">
							https://drive.google.com/file/d/1b_ay5JBRmZP_tukT-OeNceSZu7UA8br0/view?usp=drive_link
						</a><br>
						
						Inviaci questo modulo senza effettuare alcuna modifica o spostamento dei dati, per minimizzare il rischio di generare errori che potrebbero compromettere le successive fasi di invio della domanda e quindi del ricevimento dei fondi.
					</div>
					
					<template v-if="action == 'store' || (action == 'edit' && ((isCliente && pratica.id_stato_fase_1 != 30) || isAccountManager))">
						<v-badge
							:value="haveFilesBeenModified.modulo_domanda"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.modulo_domanda"
								label="Modulo di Domanda"
								hide-details
								outlined
								dense
								clearable
								accept=".pdf"
								truncate-length="120"
								@change="setChanged(files.modulo_domanda)"
								@click:clear="pratica.path_modulo_domanda = null"
								:loading="isLoadingModuloDomanda"
								:disabled="isLoading || tourIsRunning"
							>
								<template
									v-slot:append
									v-if="pratica.path_modulo_domanda !== null && !isLoadingModuloDomanda"
								>
									<template>
										<v-progress-circular
											v-if="downloadingModuloDomanda"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.path_modulo_domanda, 'modulo_domanda')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					<template v-else-if="action == 'show' || isCoordinatore || (isCliente && pratica.id_stato_fase_1 == 30)">
						<v-text-field
							:value="getFileNameFromPath(pratica.path_modulo_domanda)"
							label="Modulo di Domanda"
							hide-details
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.path_modulo_domanda !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingModuloDomanda"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_modulo_domanda, 'modulo_domanda')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>
				</v-col>
			</v-row>
			
			<v-row v-if="!isCoordinatore">
				<v-col>
					<div class="mb-4">
						<p>
							<!--Carica nel riquadro qui in basso il <b>Contratto di Servizio che hai firmato con noi</b>.-->
							Carica nel riquadro qui in basso il contratto che hai firmato con noi.
						</p>
						<p>
							<b>Se sei un consulente</b> ed hai già caricato in precedenza il contratto, <b>potrai selezionarlo dal menù a tendina senza doverlo caricare nuovamente</b>. Ti preghiamo di fare attenzione nel selezionare il contratto corretto.
						</p>
					</div>
					<template v-if="action == 'store' || (action == 'edit' && ((isCliente && pratica.id_stato_fase_1 != 30) || isAccountManager))">
						<!-- TODO: al momento l'eliminazione del contratto di servizio non è gestita per varie necessità -->
						<v-badge
							:value="haveFilesBeenModified.contratto_di_servizio"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-file-input
								v-model="files.contratto_di_servizio"
								label="Contratto di servizio"
								outlined
								dense
								clearable
								hide-details
								accept=".pdf"
								truncate-length="120"
								@change="setChanged(files.contratto_di_servizio)"
								@click:clear="onContrattoDiServizioClear()"
								:loading="isLoadingContrattoDiServizio"
								:disabled="isLoading || pratica.idPraticaConContrattoDiServizio !== null || tourIsRunning"
							>
								<template
									v-slot:append
									v-if="pratica.contratto_di_servizio.path_contratto_di_servizio !== null && !isLoadingContrattoDiServizio"
								>
									<template>
										<v-progress-circular
											v-if="downloadingContrattoDiServizio"
											size="24"
											width="3"
											color="primary"
											indeterminate
										></v-progress-circular>
										<v-icon
											v-else
											class="ml-3"
											@click="download(pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio')"
										>
											mdi-tray-arrow-down
										</v-icon>
									</template>
								</template>
							</v-file-input>
						</v-badge>
					</template>
					<template v-else-if="action == 'show' || (isCliente && pratica.id_stato_fase_1 == 30)">
						<v-text-field
							:value="getFileNameFromPath(pratica.contratto_di_servizio.path_contratto_di_servizio)"
							label="Contratto di servizio"
							outlined
							dense
							readonly
						>
							<template
								v-slot:append
								v-if="pratica.contratto_di_servizio.path_contratto_di_servizio !== null && !isCoordinatore"
							>
								<template>
									<v-progress-circular
										v-if="downloadingContrattoDiServizio"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-text-field>
					</template>
				</v-col>
			</v-row>
			
			<v-row v-if="!isCoordinatore">
				<v-col>
					<!--:value="praticaDiff.includes('contratto_di_servizio_id')"-->
					<v-badge
						:value="praticaDiff.includes('idPraticaConContrattoDiServizio')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-autocomplete
							:items="praticheConContrattiDiServizio"
							v-model="pratica.idPraticaConContrattoDiServizio"
							:loading="isLoadingPraticheConContrattiDiServizio"
							label="Scegli un Contratto di servizio già associato ad una pratica"
							item-value="id"
							item-text="nome_file_custom_id"
							outlined
							dense
							clearable
							:disabled="isLoading || files.contratto_di_servizio !== null || tourIsRunning || (isCliente && pratica.id_stato_fase_1 == 30)"
						></v-autocomplete>
					</v-badge>
				</v-col>
			</v-row>
			
			<v-row class="mt-6">
				<v-col>
					Infine inserisci in basso un <b>numero di telefono che deve appartenere alla persona responsabile della pratica</b> che ha a disposizione tutte le informazioni sul progetto e sull’azienda che sta partecipando al Click Day e <b>DEVE essere reperibile il giorno e nella fascia oraria del Click Day</b>.
					Verrà contattato solo nell’improbabile caso in cui le informazioni a nostra disposizione non fossero sufficienti a rispondere alle domande integrative richieste dalla procedura di invio della domanda il giorno del Click Day. Consigliamo di inserire un <b>numero di cellulare</b> o in alternativa un numero fisso (<b>no centralino</b>).
				
				</v-col>
			</v-row>
			<v-row class="mt-0">
				<v-col cols="6">
					<v-badge
						:value="praticaDiff.includes('numero_di_emergenza')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-text-field
							:value="pratica.numero_di_emergenza"
							@input="pratica.numero_di_emergenza = $event !== '' ? $event : null"
							label="Numero di emergenza"
							outlined
							dense
							hide-details
							:readonly="(isCliente && pratica.id_stato_fase_1 == 30) || isCoordinatore || action == 'show'"
							:disabled="tourIsRunning"
						></v-text-field>
					</v-badge>
				</v-col>
			</v-row>
			
			<!--<v-row class="mt-0">-->
			<!--	<v-col>-->
			<!--		Questo numero deve appartenere alla persona che ha a disposizione tutte le informazioni sull’azienda che sta partecipando al Click Day e DEVE essere reperibile il giorno e nella fascia oraria del Click Day.<br>-->
			<!--		Verrà contattato solo nell’improbabile caso in cui le informazioni a nostra disposizione non fossero sufficienti a rispondere alle domande integrative richieste dalla procedura di invio della domanda il giorno del Click Day.-->
			<!--	</v-col>-->
			<!--</v-row>-->
			
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
const mime = require('mime');
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'haveFilesBeenModified'],
	data() {
		return {
			isSettingPratica: false,
			backupPratica: {},
			pratica: {
				id: null,
				accordo_id: null,
				id_stato_fase_1: null,
				ci_sono_aggiornamenti_fase_1: false,
				numero_di_emergenza: null,
				priorita: null,
				path_attestazione_predisposizione_domanda: null,
				path_modulo_domanda: null,
				contratto_di_servizio_id: null,
				contratto_di_servizio: {
					id: null,
					path_contratto_di_servizio: null
				},
				idPraticaConContrattoDiServizio: null // dato extra aggiunto
			},
			files: {
				attestazione_predisposizione_domanda: null,
				modulo_domanda: null,
				contratto_di_servizio: null
			},
			isLoadingAttestazionePredisposizioneDomanda: false,
			isLoadingModuloDomanda: false,
			isLoadingContrattoDiServizio: false,
			
			praticheConContrattiDiServizio: [],
			isLoadingPraticheConContrattiDiServizio: false,
			
			downloadingAttestazionePredisposizioneDomanda: false,
			downloadingModuloDomanda: false,
			downloadingContrattoDiServizio: false,
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.backupPratica = Object.assign({}, this.value);
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_1 && this.isCliente) {
			// TODO: Correggere questo comportamento:
			//  quando aggiorno la variabile qua sotto vengono rilevate delle modifiche della pratica dalla computed praticaDiff()
			//  e di conseguenza anche la computed changesHaveBeenMade() restituirà true ed il testo del bottone che dovrebbe essere "Chiudi"
			//  diventa "Annulla" come se ci fosse stata una modifica mentre in realtà sto solo segnando l'aggiornamento come letto
			this.pratica.ci_sono_aggiornamenti_fase_1 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_1',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_1');
		}
		
		if (this.pratica.ci_sono_aggiornamenti_per_account_manager_fase_1 && this.isAccountManager) {
			this.pratica.ci_sono_aggiornamenti_per_account_manager_fase_1 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_per_account_manager_fase_1',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_per_account_manager_fase_1');
		}
		
		if (this.pratica.path_attestazione_predisposizione_domanda !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getAttestazionePredisposizioneDomanda();
		}
		
		if (this.pratica.path_modulo_domanda !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getModuloDomanda();
		}
		
		if (this.pratica.contratto_di_servizio.path_contratto_di_servizio !== null && ((this.action != 'show' && this.isAccountManager) || this.isCliente)) {
			this.getContrattoDiServizio();
		}
		
		this.getPraticheConContrattoDiServizio();
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			tourIsRunning: 'tour/isRunning'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingAttestazionePredisposizioneDomanda
				|| this.isLoadingModuloDomanda
				|| this.isLoadingContrattoDiServizio
				|| this.isLoadingPraticheConContrattiDiServizio;
		},
		nessunFileCaricato() {
			return this.pratica.path_attestazione_predisposizione_domanda === null
				&& this.pratica.path_modulo_domanda === null
				&& this.pratica.contratto_di_servizio.path_contratto_di_servizio === null;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica);
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		}
	},
	
	methods: {
		async getAttestazionePredisposizioneDomanda() {
			this.isLoadingAttestazionePredisposizioneDomanda = true;
			this.files.attestazione_predisposizione_domanda = await this.getFile(this.pratica.path_attestazione_predisposizione_domanda);
			this.files.attestazione_predisposizione_domanda.changed = false;
			this.isLoadingAttestazionePredisposizioneDomanda = false;
		},
		async getModuloDomanda() {
			this.isLoadingModuloDomanda = true;
			this.files.modulo_domanda = await this.getFile(this.pratica.path_modulo_domanda);
			this.files.modulo_domanda.changed = false;
			this.isLoadingModuloDomanda = false;
		},
		async getContrattoDiServizio() {
			this.isLoadingContrattoDiServizio = true;
			this.files.contratto_di_servizio = await this.getFile(this.pratica.contratto_di_servizio.path_contratto_di_servizio);
			this.files.contratto_di_servizio.changed = false;
			this.isLoadingContrattoDiServizio = false;
		},
		getPraticheConContrattoDiServizio() {
			this.isLoadingPraticheConContrattiDiServizio = true;
			axios.get(`/api/pratiche?pratiche_con_contratto_di_servizio=true&accordo_id=${this.pratica.accordo_id}`)
				.then(response => {
					this.praticheConContrattiDiServizio = response.data;
				})
				.finally(() => {
					this.isLoadingPraticheConContrattiDiServizio = false;
				})
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'attestazione_predisposizione_domanda') this.downloadingAttestazionePredisposizioneDomanda = true;
			else if (key == 'modulo_domanda') this.downloadingModuloDomanda = true;
			else if (key == 'contratto_di_servizio') this.downloadingContrattoDiServizio = true;
			axios.post('/api/storage/download',
				{
				path: path
			},
				{
				responseType: 'blob'
			})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'attestazione_predisposizione_domanda') this.downloadingAttestazionePredisposizioneDomanda = false;
					else if (key == 'modulo_domanda') this.downloadingModuloDomanda = false;
					else if (key == 'contratto_di_servizio') this.downloadingContrattoDiServizio = false;
				})
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
		},
		onContrattoDiServizioClear() {
			this.pratica.contratto_di_servizio.path_contratto_di_servizio = null;
			this.pratica.contratto_di_servizio_id = null;
			this.pratica.contratto_di_servizio = Object.assign({}, this.praticaVoid.contratto_di_servizio);
			this.$emit('update-fase-2-key');
			this.$emit('update-fase-6-key');
		},
		downloadAllFiles() {
			if (this.pratica.path_attestazione_predisposizione_domanda) {
				this.download(this.pratica.path_attestazione_predisposizione_domanda, 'attestazione_predisposizione_domanda');
			}
			
			if (this.pratica.path_modulo_domanda) {
				this.download(this.pratica.path_modulo_domanda, 'modulo_domanda');
			}
			
			if (this.pratica.contratto_di_servizio.path_contratto_di_servizio) {
				this.download(this.pratica.contratto_di_servizio.path_contratto_di_servizio, 'contratto_di_servizio');
			}
		}
	}
	
}
</script>

<style scoped>

</style>